import Collapse from '../lib/collapse';
export default class FooterMenu {
    constructor() {
        this.initListeners()
        if (window.innerWidth <= 576) {
            this.init()
        }
    }

    init() {
        let collapseElementList = [].slice.call(document.querySelectorAll('[data-js-footer-list-menu]'))
        this.collapseList = collapseElementList.map(function (collapseEl) {
            return new Collapse(collapseEl);
        })
    }

    initListeners() {
        let elements = document.querySelectorAll('[data-js-footer-menu]');
        elements.forEach((el) => {
            el.addEventListener('click', (e) => {
                if (this.collapseList && window.innerWidth <= 576) {
                    let title = e.target;
                    title.classList.toggle('hidden')
                    let target = title.dataset.target;
                    this.collapseList.forEach((collapse) => {
                        if (collapse.element.id === target) {
                            collapse.toggle()
                        }
                    })
                }
            })
        })

        window.addEventListener('resize', () => {
            if (window.innerWidth <= 576) {
                this.init()
            } else {
                if (this.collapseList) {
                    this.collapseList.forEach((el) => {
                        el.show()
                    })
                }
            }
        }, {passive: true})
    }
}
